export const queryPage = '/icps/system/sign/cloudSell/notes/queryPage'
export const Download = '/icps/system/sign/cloudSell/notes/exportEngineeringNotes'
export const saveOrUpdate = '/icps/system/sign/cloudSell/notes/saveOrUpdate'
export const deleteNotes = '/icps/system/sign/cloudSell/notes/deleteNotes'
import request from '@/utils/request'
export function queryEngineering(data) {
  return request({
    url: '/icps/system/sign/cloudSell/notes/queryEngineering',
    method: 'get',
    params: data
  })
}
export function queryInvoicedAmount(data) {
  return request({
    url: '/icps/system/sign/cloudSell/notes/queryInvoicedAmount',
    method: 'get',
    params: data
  })
}